<span class="go-back-component" (click)="onBack()">
    <!-- < arrow-left -->

    <div class="fa fa-chevron-left" aria-hidden="true"></div>
</span>